import { F0Box, F0Heading, F0Text } from '@factorialco/f0-react'

import i18n from 'modules/core/lib/i18n'

const DiscoverCardsHeader = () => {
  return (
    <F0Box display="flex" flexDirection="column" gap="xs">
      <F0Heading variant="heading" content={i18n.t('ai_reports.discover.cards_header.title')} />
      <F0Text
        variant="description"
        content={i18n.t('ai_reports.discover.cards_header.description')}
      />
    </F0Box>
  )
}

export default DiscoverCardsHeader
